import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

export function setupFilters(app) {
  const filters = app.config.globalProperties.$filters || {}
  filters.NumberFormat = function (value) {
    if (!value) {
      return '0'
    }
    const intPartFormat = value
      .toString()
      .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    return intPartFormat
  }

  filters.dayjs = function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)
  }

  filters.moment = function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)
  }

  app.config.globalProperties.$filters = filters
}
